<!-- Colored change indicator (prototype `.verschil`): green up / red down / muted equal. -->
<template>
    <p v-if="change" class="verschil change-badge" :class="kindClass">{{ text }}</p>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    // { kind: "up" | "down" | "equal" | "nodata", percent: number }
    change: { type: Object, default: null },
    label: { type: String, default: "" },
});

const kindClass = computed(() => {
    const kind = props.change?.kind;
    if (kind === "up") return "op";
    if (kind === "down") return "af";
    return "gelijk";
});

const text = computed(() => {
    const change = props.change;
    if (!change || change.kind === "nodata") {
        return `No data for ${props.label}`;
    }
    if (change.kind === "equal") {
        return `Same as ${props.label}`;
    }
    const arrow = change.kind === "up" ? "▲ +" : "▼ −";
    return `${arrow}${Math.abs(change.percent)}% vs ${props.label}`;
});
</script>

<style scoped lang="scss">
/* Only the panel-level spacing is local; the colored look is shared `.verschil`. */
.change-badge {
    margin: 0 0 var(--s-3);
}
</style>
